module.exports = __webpack_public_path__ + "img/50ae420.png";